import React from 'react';
import { useRouter } from 'next/navigation';
import { useLocaleFormat } from '@/shared/hooks/useLocaleFormat';
import { BodyTextMediumB } from '@/shared/ui/typography2';
import { Button } from '@/shared/ui/form/button/button';
import { useScopedI18n } from '@locales/client';
import { ButtonBox } from './styles';

interface WelcomeBonusBtnProps {
  dataWelcomeAvailable?: {
    id: string | number;
  };
}

export const WelcomeBonusBtn = ({ dataWelcomeAvailable }: WelcomeBonusBtnProps) => {
  const router = useRouter();
  const formatUrl = useLocaleFormat();
  const tLoyalty = useScopedI18n('loyalty');

  const handleButtonClick = () => {
    const bonusId = dataWelcomeAvailable?.id;
    if (!bonusId) return;
    
    router.push(formatUrl(`bonuses?bonusID=${bonusId}`));
  };

  const isButtonDisabled = !dataWelcomeAvailable?.id;

  return (
    <ButtonBox>
      <Button
        type="button"
        variant="orangeGradient"
        onClick={handleButtonClick}
        disabled={isButtonDisabled}
        style={{ width: '100%' }}
      >
        <BodyTextMediumB>
          {tLoyalty('take_bonus')}
        </BodyTextMediumB>
      </Button>
    </ButtonBox>
  );
};
